import { GET_ORDERS, GET_ORDERS_FAILED, SET_LOADING_STATUS } from 'redux/types';

const INIT_STATE = {
  ordersList: [],
  isLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_LOADING_STATUS:
      return { ...state, isLoading: action.payload };
    case GET_ORDERS:
      return { ...state, ordersList: action.payload, isLoading: false };
    case GET_ORDERS_FAILED:
      return { ...state, ordersList: [], isLoading: false };
    default:
      return { ...state };
  }
};
